import moment from "moment";

export interface TimeUntilDate {
  value: number;
  unit: "hour" | "day";
  displayText: string;
}

export const getTrialDaysRemaining = (endDate: string): TimeUntilDate => {
  const now = moment().startOf("day");
  const end = moment(endDate).endOf("day");
  const diffInHours = end.diff(now, "hours");
  const diffInDays = end.diff(now, "days");

  if (diffInHours < 24) {
    return {
      value: diffInHours,
      unit: "hour",
      displayText: `${diffInHours} hour${diffInHours !== 1 ? "s" : ""}`,
    };
  }
  return {
    value: diffInDays,
    unit: "day",
    displayText: `${diffInDays} day${diffInDays !== 1 ? "s" : ""}`,
  };
};
